const DEFAULT_SCENE = 'reports-adherence';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

const LIST = `${DEFAULT_SCENE}:list`;
export const LIST_CONTAINER_TAG = `${LIST}:container`;
export const LIST_PAGINATION_TAG = `${LIST}:pagination`;

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;

export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;

// SideBar for Legend
const LEGEND_SIDEBAR = `${DEFAULT_SCENE}:legend-sidebar`;
export const TOGGLE_LEGEND_BUTTON_TAG = `${LEGEND_SIDEBAR}:button-toggle`;
export const HIDE_ALL_KPI_BUTTON_TAG = `${LEGEND_SIDEBAR}:button-hide-all-kpi`;
export const SHOW_ALL_KPI_BUTTON_TAG = `${LEGEND_SIDEBAR}:button-show-all-kpi`;
export const KPI_VISIBILITY_TOGGLE_BUTTON_TAG = `${LEGEND_SIDEBAR}:button-kpi-visibility-toggle:`;

// Export
export const EXPORT_MENU_BUTTON_TAG = `${DEFAULT_SCENE}:export-menu:button`;
export const EXPORT_RAW_DATA_BUTTON_TAG = `${FILTER_SIDEBAR}:export-raw-data:button-toggle`;
export const EXPORT_CALCULATED_DATA_BUTTON_TAG = `${FILTER_SIDEBAR}:export-calculated-data:button-toggle`;
